import { addToast } from '@/services/toastService'

export const showToastSuccess = (message) => {
  addToast(message, 'success')
}

export const showToastError = (message) => {
  addToast(message, 'error')
}

export const showToastWarning = (message) => {
  addToast(message, 'warning')
}

export const showToastInfo = (message) => {
  addToast(message, 'info')
}
